export default "__VITE_ASSET__e1SszXPQ__"